import React from 'react';
import { Eye, BellRing, Zap } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';

const STEPS = [
  { icon: Eye, number: '01', titleKey: 'landingWorkflowStep1Title', descKey: 'landingWorkflowStep1Desc' },
  { icon: BellRing, number: '02', titleKey: 'landingWorkflowStep2Title', descKey: 'landingWorkflowStep2Desc' },
  { icon: Zap, number: '03', titleKey: 'landingWorkflowStep3Title', descKey: 'landingWorkflowStep3Desc' },
];

export default function LandingWorkflowSection() {
  const { t } = useLocale();

  return (
    <section className={`${themeClasses.landing.section} border-y border-border-light bg-background-secondary`}>
      <div className={themeClasses.landing.container}>
        <h2 className="text-display-lg mx-auto max-w-2xl text-center">{t('landingWorkflowTitle')}</h2>
        <ol className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-8">
          {STEPS.map(({ icon: Icon, number, titleKey, descKey }, index) => (
            <li
              key={titleKey}
              className={`flex flex-col gap-4 ${index < STEPS.length - 1 ? 'lg:border-r lg:border-border-light lg:pr-8' : ''}`}
            >
              <div className="flex items-center gap-3">
                <span className={themeClasses.landing.stepNumber}>{number}</span>
                <Icon className="size-5 text-brand-600" aria-hidden />
              </div>
              <h3 className="text-xl font-semibold tracking-tight text-text-primary">{t(titleKey)}</h3>
              <p className="text-sm leading-relaxed text-text-secondary">{t(descKey)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
